import React, { useState } from "react";
import facebook from "../../assets/images/facebook.png";
import instagram from "../../assets/images/instagram.png";
import linkedin from "../../assets/images/linkedin.png";
import youtube from "../../assets/images/youtube.png";
import BookDemoForm from "../BookDemoForm/BookDemoForm";

const Contacts = () => {
  const [showFormModal, setShowFormModal] = useState(false);

  const handleFormToggle = () => {
    setShowFormModal(!showFormModal);
  };

  return (
    <footer className="bg-gray-100 py-8">
      <div className="container mx-auto px-4 text-center">
        <div className="flex flex-col justify-between items-center">
          <div className="text-gray-700 mb-4 md:mb-0">
            <div>
              <strong>(India Sales)</strong> <br />
              <a href="tel:+919591576806">+91 9591576806</a>
            </div>

            <div>
              <strong>(Email Us)</strong> <br />
              <a href="mailto:saurabh@smartnexussolutions.com">
                saurabh@smartnexussolutions.com
              </a>
            </div>
          </div>
          <div className="my-4 md:mb-0">
            <button
              className="bg-black text-white px-4 py-2 rounded"
              onClick={handleFormToggle}
            >
              Book a Demo

            </button>
          </div>
        </div>
        <div className="flex justify-center mt-8 space-x-4">
          <button aria-label="Facebook">
            <a
              href="https://www.facebook.com/people/Smart-Nexus-Solutions/61567693179872/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={facebook} alt="Facebook" className="h-6" />
            </a>
          </button>

          <button aria-label="LinkedIn">
            <a
              href="https://www.linkedin.com/company/smart-nexus-solutions/?viewAsMember=true"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={linkedin} alt="LinkedIn" className="h-6" />
            </a>
          </button>

          <button aria-label="YouTube">
            <a
              href="https://www.youtube.com/channel/UCk9F7NtMRDKxsZCde9fmbLQ"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={youtube} alt="YouTube" className="h-6" />
            </a>
          </button>
          <button aria-label="Instagram">
            <a
              href="https://www.instagram.com/smart_nexus.ai/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <img src={instagram} alt="Instagram" className="h-6" />
            </a>
          </button>
        </div>
      </div>
      {showFormModal && <BookDemoForm onClose={handleFormToggle} />}
    </footer>
  );
};

export default Contacts;
